$(document).ready(function () {
    if (SitecoreForm.formValidation().ShowThankYou) {
      
        $(document.body).animate({ scrollTop: $('#contactUsForm').offset().top });
    }
});